import type { PublishPostParams } from '../types';

import { useMutation } from '@tanstack/react-query';

import { publishPost } from '../api';

export function usePublishFacebookPost() {
  return useMutation({
    mutationFn: ({
      pharmacyId,
      pageId,
      params,
    }: {
      pharmacyId: string;
      pageId: string;
      params: PublishPostParams;
    }) => publishPost(pharmacyId, pageId, params),
  });
}
